export const NOTIFICATION_SUPPORTING_SPORTS: string[] = [
  'Soccer',
  'Basketball',
  'Tennis',
  'TableTennis',
  'Volleyball',
  'Baseball',
  'IceHockey',
  'LeagueOfLegends',
  'Dota2',
  'CyberFootball',
  'CounterStrike'
];
